'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryVideoEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseLoader = require('@bibliocommons/base-loader');

var _baseLoader2 = _interopRequireDefault(_baseLoader);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _loginLink = require('../../login-link');

var _loginLink2 = _interopRequireDefault(_loginLink);

var _simpleUgcPermalink = require('../../simple-ugc-permalink');

var _simpleUgcPermalink2 = _interopRequireDefault(_simpleUgcPermalink);

var _videoForm = require('../../video-form');

var _videoForm2 = _interopRequireDefault(_videoForm);

require('../styles/PrimaryVideoEditor.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrimaryVideoEditor = exports.PrimaryVideoEditor = function (_BcReactComponent) {
  _inherits(PrimaryVideoEditor, _BcReactComponent);

  function PrimaryVideoEditor() {
    _classCallCheck(this, PrimaryVideoEditor);

    return _possibleConstructorReturn(this, (PrimaryVideoEditor.__proto__ || Object.getPrototypeOf(PrimaryVideoEditor)).apply(this, arguments));
  }

  _createClass(PrimaryVideoEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* testing */}
  }, {
    key: 'recoveryLink',
    value: function recoveryLink() {
      return _react2.default.createElement(
        _baseButtons.Button,
        { className: 'recovery-link', handleClick: this.props.handleNerfRecovery },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error_ugc_broken_retry_button' })
      );
    }
  }, {
    key: 'recoveryInfo',
    value: function recoveryInfo() {
      return _react2.default.createElement(
        'div',
        { className: 'recovery-info' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error_ugc_recovery_info', values: { tries: this.props.initializingStatus.tries || 1, retry_link: this.recoveryLink() } })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          embedSnippet = _props.embedSnippet,
          bibId = _props.bibId,
          fieldErrors = _props.fieldErrors,
          isPrivate = _props.isPrivate,
          handlePrivacyToggle = _props.handlePrivacyToggle,
          iFrameSrc = _props.iFrameSrc,
          isNew = _props.isNew,
          showForm = _props.showForm,
          handleCancelPreview = _props.handleCancelPreview,
          handleDescriptionChange = _props.handleDescriptionChange,
          handleEmbedSnippetChange = _props.handleEmbedSnippetChange,
          handleSubmit = _props.handleSubmit,
          handleTitleChange = _props.handleTitleChange,
          handleLogin = _props.handleLogin,
          videoTitle = _props.videoTitle,
          description = _props.description,
          user = _props.user,
          initializingStatus = _props.initializingStatus,
          userContentId = _props.userContentId,
          handleCancel = _props.handleCancel,
          handleNerfRecovery = _props.handleNerfRecovery;


      if (initializingStatus.status === 'pending') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_baseLoader2.default, null)
        );
      }

      if (initializingStatus.status === 'failure') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _baseAlerts.AlertFailure,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: initializingStatus.localeKey, values: { recoveryInfo: this.recoveryInfo() } })
          )
        );
      }

      if (user.loggedIn) {
        if (showForm) {
          return _react2.default.createElement(_videoForm2.default, {
            fieldErrors: fieldErrors,
            embedSnippet: embedSnippet,
            isNew: isNew,
            videoTitle: videoTitle,
            showPreview: !!iFrameSrc,
            description: description,
            iFrameSrc: iFrameSrc,
            handleTitleChange: handleTitleChange,
            handleDescriptionChange: handleDescriptionChange,
            handleEmbedSnippetChange: handleEmbedSnippetChange,
            handleSubmit: handleSubmit,
            submitButtonText: 'add_video',
            handleCancel: handleCancel,
            handleCancelPreview: handleCancelPreview,
            handleNerfRecovery: handleNerfRecovery });
        }

        return _react2.default.createElement(_simpleUgcPermalink2.default, {
          bibId: bibId,
          userContentId: userContentId,
          ugcType: 'video',
          isPrivate: isPrivate,
          handlePrivacyToggle: handlePrivacyToggle });
      }

      return _react2.default.createElement(
        'div',
        { className: 'well login' },
        _react2.default.createElement(
          _loginLink2.default,
          { handleLogin: handleLogin },
          _react2.default.createElement(_baseIcons.Video, null),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login_to_add_video' })
        )
      );
    }
  }]);

  return PrimaryVideoEditor;
}(_baseBcReactComponent2.default);

PrimaryVideoEditor.propTypes = {
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  user: _react.PropTypes.shape({
    loggedIn: _react.PropTypes.bool
  }).isRequired,
  initializingStatus: _react.PropTypes.shape({
    status: _react.PropTypes.string
  }).isRequired,
  videoTitle: _react.PropTypes.string,
  showPreview: _react.PropTypes.bool,
  description: _react.PropTypes.string,
  handleCancelPreview: _react.PropTypes.func.isRequired,
  handleDescriptionChange: _react.PropTypes.func.isRequired,
  handleEmbedSnippetChange: _react.PropTypes.func.isRequired,
  handleLogin: _react.PropTypes.func.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  handleTitleChange: _react.PropTypes.func.isRequired,
  bibId: _react.PropTypes.number.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  handleNerfRecovery: _react.PropTypes.func.isRequired,
  userContentId: _react.PropTypes.number,
  iFrameSrc: _react.PropTypes.string,
  isNew: _react.PropTypes.bool,
  showEmbedForm: _react.PropTypes.bool,
  showForm: _react.PropTypes.bool,
  embedSnippet: _react.PropTypes.string,
  intl: _reactIntl.intlShape,
  handleCancel: _react.PropTypes.func
};

exports.default = (0, _reactIntl.injectIntl)(PrimaryVideoEditor);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/primary-video-editor/components/PrimaryVideoEditor.js
// module id = 1533
// module chunks = 1